import { MutableRefObject, useEffect, useMemo, useRef } from 'react'

export function useEffectWithRefs<Refs>(
  callback: (refs: MutableRefObject<Refs>) => void,
  dependencies: any[],
  refs: Refs
) {
  const refsRef = useRef(refs)
  refsRef.current = refs
  useEffect(() => callback(refsRef), dependencies)
}

export function useMemoWithRefs<Memoized, Refs>(
  callback: (refs: MutableRefObject<Refs>) => Memoized,
  dependencies: any[],
  refs: Refs
): Memoized {
  const refsRef = useRef(refs)
  refsRef.current = refs
  /*
    eslint-disable-next-line react-hooks/use-memo --

    This utility hook intentionally accepts a dynamic dependency array as a parameter.
    The React Compiler cannot statically analyze this, but it's by design - this hook
    allows callers to specify their own dependencies while also accessing refs.
  */
  return useMemo(() => callback(refsRef), dependencies)
}
